<template>
  <div class="profile">
    <PageHeader :title="pageTitle">
      <Button @click="cancel">{{
        getMessageByLang("cancel", "Отмена")
      }}</Button>
      <Button :theme-color="'primary'" @click="handleSubmit">
        {{ getMessageByLang("btnSave", "Сохранить") }}
      </Button>
    </PageHeader>

    <VLoader v-if="isLoading" />
    <div v-else>
      <form @submit="handleSubmit" class="profile__form">
        <div class="form-group">
          <LabelRequired>
            {{ getMessageByLang("nameText", "Имя") }}
          </LabelRequired>
          <div class="form-option-required-wrap">
            <Input
              v-model="profile.name"
              :placeholder="getMessageByLang('enterNameOption', 'Введите имя')"
              class="input-error"
              :valid="isValidName"
            />
          </div>
        </div>
        <div class="form-group">
          <label>
            {{ getMessageByLang("contactInfoText", "Контактная информация") }}
          </label>
          <Input
            v-model="profile.contact_info"
            :placeholder="
              getMessageByLang(
                'enterNameOption',
                'Введите контактную информацию'
              )
            "
            :valid="isValidContactInfo"
          />
        </div>
        <div class="form-group">
          <label>
            {{ getMessageByLang("contactInfoText", "Контактная информация") }}
          </label>
          <div
            class="profile__status"
            :class="{ active: profile.status === 'active' }"
          >
            {{ renderStatus(profile.status) }}
          </div>
        </div>
      </form>
    </div>

    <AppNotification
      :text="textNotification"
      :close="handleCloseNotification"
      v-if="textNotification"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { getMessageByLang } from "@/utils/translate.js";
import { isValidText } from '@/utils/form-validation.js';

import VLoader from "@/ui-kit/components/VLoader.vue";
import PageHeader from "@/components/page/PageHeader.vue";
import AppNotification from "@/components/AppNotification.vue";
import LabelRequired from "@/components/forms/LabelRequired.vue";

import { Button } from "@progress/kendo-vue-buttons";
import { Input } from "@progress/kendo-vue-inputs";

import api from "@/api";

const profile = ref({});
const isLoading = ref(true);
const pageTitle = getMessageByLang("profile", "Профиль");
const textNotification = ref(null);
const isValidName = ref(true);
const isValidContactInfo = ref(true)


const cancel = () => {
  location.reload();
}

const handleSubmit = async () => {
  try {
    textNotification.value = null;
    isValidName.value = true;
    isValidContactInfo.value = true;

    if (!isValidText(profile.value.name)) {
      textNotification.value = "Заполните имя";
      isValidName.value = false;
    }

    if (!isValidText(profile.value.contact_info)) {
      textNotification.value = "Заполните контактную информацию";
      isValidContactInfo.value = false;
    }

    if(textNotification.value) {
      textNotification.value = null;
      return;
    }

    const reqData = {
      name: profile.value.name,
      contact_info: profile.value.contact_info,
    };

    const response = await api.profile.update(reqData);
    textNotification.value = response?.data?.message || "Успешно";
  } catch (err) {
    console.log("in error");
    console.error(err);
  }
};

const handleCloseNotification = () => {
  textNotification.value = false;
};

const renderStatus = (status) => {
  switch (status) {
    case "active":
      return "Активный";

    default:
      return "Не активный";
  }
};

const getProfile = async () => {
  try {
    const response = await api.profile.get();
    profile.value = response?.data?.data;

  } catch (err) {
    console.error(err);

  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  getProfile();
});
</script>

<style lang="scss" scoped>
.profile {
  &__form {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &__status {
    color: #999999;

    &.active {
      color: green;
    }
  }
}
</style>